// extracted by mini-css-extract-plugin
export default {"chatting_box_wrap":"chattingBox_chatting_box_wrap__2f72c"};